import { action, observable, flow, makeObservable } from "mobx";
import * as _ from "lodash";

import { EAIClient } from "Services/EAIClient";
import { appStore } from "../";
import { Ticket } from "../dashboardStore/tickets";

export interface ReportPermissions {
    can_edit: boolean,
    can_delete: boolean,
    can_download: boolean,
    can_view: boolean,
    can_print: boolean
}

export interface Report {
    [idx: string]: string | string[] | Ticket[] | boolean | Date | ReportPermissions

    id: string
    created_by: string
    created_by_name: string
    created_by_email: string
    name: string
    summary: string
    tickets: Ticket[]
    include_comments: boolean
    include_screenshots: boolean
    ordering: string[]
    generated: Date
    created: Date
    updated: Date
    permissions: ReportPermissions
}

class ReportStore {

    @observable reports: Report[];
    @observable report: Report;
    @observable selectedTickets: Ticket[];
    @observable reportUrl: string;
    @observable isProcessing: boolean;

    @observable isPrinting: boolean;
    @observable printingReport: string;

    @observable isViewing: boolean;
    @observable viewingReport: string;

    @observable isDownloading: boolean;
    @observable downloadingReport: string;

    client = new EAIClient();

    constructor() {
        makeObservable(this);
    }

    @flow
    * fetchReports(): any { // TS identifies these as returning IterableIterator<Promise<AxiosResponse<any>>> even though they are Promise at runtime
        try {
            const resp = yield this.client.fetchReports();
            this.reports = resp.data.data;
        } catch(e) {
            appStore.addError(e);
        }
    }

    @flow
    * createReport(data: any): any{
        this.isProcessing = true;
        data.tickets = this.selectedTickets.map((t: Ticket) => t.ruuid || "");
        try {
            const resp = yield this.client.createReport(data);
            this.report = resp.data.data;
            this.isProcessing = false;
            // update report list
            this.fetchReports();
        } catch(e) {
            this.isProcessing = false;
            appStore.addError(e);
        }
    }

    @action
    addTicketToExistingReport(id: string, ticket: Ticket){
        // not needed yet
        if(!this.report || this.report.id !== id) return;
        if(!this.report.tickets) this.report.tickets = [];
        const idx = _.findIndex(this.report.tickets.slice(), {ruuid: ticket.ruuid});
        // add if not already in list
        if(idx === -1) this.report.tickets.push(ticket);
    }

    @action
    toggleTicket(ticket: Ticket){
        if(!this.selectedTickets) this.selectedTickets = [];
        // check if exists
        const idx = _.findIndex(this.selectedTickets.slice(), {ruuid: ticket.ruuid});
        if(idx > -1){
            // remove ticket
            this.selectedTickets.splice(idx, 1);
        } else {
            this.selectedTickets.push(ticket);
        }
    }

    @action
    setTicketSelection(tickets: Ticket[]){
        this.selectedTickets = tickets;
    }

    @action
    clearSelectedTickets(){
        this.selectedTickets = [];
    }
}

const reportStore = new ReportStore();

export default reportStore;
export { ReportStore };
